import React from "react";
import containerCss from "./container.module.css";

const Container = ({ children }) => (
    <div className={ containerCss.container }>{ children }</div>
);

export {
    Container
};